var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"back",style:([_vm.transparent?{background: 'transparent', backdropFilter: 'none'}:{}, _vm.top?{top: _vm.top}:{}, _vm.left?{left: _vm.left}:{}])},[_c('div',{staticClass:"dialogboxv2",style:({
    width: `${_vm.width}px`,
    minWidth: `${_vm.width}px`,
    maxWidth: `${_vm.width}px`,
    maxHeight: _vm.height ? `${_vm.height}px` : 'fit-content'
  })},[_c('div',{staticClass:"headerBox",style:(_vm.haadBg?{backgroundColor:_vm.haadBg}:{})},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('button',{staticClass:"closeBtn",on:{"click":function($event){return _vm.$emit('close')}}},[_c('iconClose',{attrs:{"width":25,"height":25,"color":"#FFFFFF","backgroundColor":"none"}})],1)]),_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }